import { createSlice } from "@reduxjs/toolkit";

export const getFavoritesList = (viewsMenuUser) => {
  return viewsMenuUser?.filter((menu) => menu.Favorito) || [];
};

const favoritosMenuSlice = createSlice({
  name: "favoritosMenuReducer",
  initialState: {
    favoritos: getFavoritesList(),
  },
  reducers: {
    updateFavoritos: {
      reducer(state, { payload }) {
        state.favoritos = payload;
      },
    },
  },
});

const { actions, reducer } = favoritosMenuSlice;

export const { updateFavoritos } = actions;

export default reducer;
